import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar,} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {PaymentPageVO, useQueryPaymentPage} from "@/service/payment.s";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WritePayment} from "@/pages/Payment/WritePayment";
import Box from "@mui/material/Box";
import {ViewPayment} from "@/pages/Payment/ViewPayment";
import {Avatar} from "@mui/material";
import {permScope} from "@/helper/constant";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

export const PaymentListPage = () => {
    const {
        mutate: paymentPageMutate,
        data: paymentPageData,
        isPending: paymentPagePending,
    } = useQueryPaymentPage()
    const {role: {dataScope}, id} = useAuthInfo()

    const columns: GridColDef<PaymentPageVO>[] = [
        {field: "customerName", headerName: "客户名称", flex: 0.8, minWidth: 160},
        {
            field: "patentName",
            headerName: "专利名称",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "amount",
            headerName: "缴费金额",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.amount}`}</Box>
        },
        {
            field: "deadline",
            headerName: "最后期限",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            valueFormatter: (value) => formatTime("D", value) || '-',
        },
        {
            field: "receivingMethod",
            headerName: "到账方式",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 0.6
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<PaymentPageVO>
            loading={paymentPagePending}
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewPayment mode={'drawer'}/>, write: <WritePayment/>}}
            columns={columns}
            data={paymentPageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: PaymentPageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WritePayment/>}
                    }
                }
            }}
            onSearch={(params) => {
                paymentPageMutate(params);
            }}
            code={"payment"}
        />
    );
};
